// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress'
import { Divider } from '@mui/material'
import axios from 'axios'
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider';

export default function Index() {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const { showToast } = useToast();

  // ** State
  const [listData, setListData] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    getData()
  }, [])

  const getData = () => {
    setListData([])
    showToast("Loading", "loading");
    const url = apiUrl.apiUrl + '/production/planning-produksi/list'
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setListData(data)
        } else {
          showToast(response.data.message, 'error');
        }
      })
  }

  const hiddenColumns = ['tgl_raw']

  const convertComponent = [
    {
      key: 'steps',
      caption: 'Timeline Produksi',
      minWidth: 650,
      renderCell: ({ row }: any) => {
        const steps = row.data?.steps || [];

        if (!steps.length) {
          return <span style={{ color: '#999' }}>Belum ada proses</span>;
        }

        const color = (status: string) => {
          if (status === 'DONE') return '#2ecc71';
          if (status === 'PROGRESS') return '#f39c12';
          return '#bdc3c7';
        };

        const icon = (status: string) => {
          if (status === 'DONE') return '✔';
          if (status === 'PROGRESS') return '⏳';
          return '○';
        };

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '6px 0'
            }}
          >
            {steps.map((step: any, i: number) => {
              const percent =
                step.qty_plan > 0
                  ? Math.min(
                    100,
                    Math.round((step.qty_hasil / step.qty_plan) * 100)
                  )
                  : 0;

              return (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                  }}
                >
                  {/* STEP */}
                  <div
                    style={{
                      minWidth: 110,
                      padding: '8px 10px',
                      borderRadius: 10,
                      background: '#f9fafb',
                      borderTop: `4px solid ${color(step.status)}`,
                      textAlign: 'center'
                    }}
                  >
                    <div style={{ fontWeight: 600 }}>
                      {icon(step.status)} {step.nama}
                    </div>

                    <div style={{ fontSize: 11, color: '#777', marginTop: 2 }}>
                      {step.jam_mulai || '--'} – {step.jam_selesai || '--'}
                    </div>

                    <div style={{ fontSize: 11, marginTop: 4 }}>
                      {step.qty_hasil}/{step.qty_plan}
                    </div>

                    {/* MINI PROGRESS */}
                    <div
                      style={{
                        marginTop: 4,
                        height: 4,
                        background: '#e0e0e0',
                        borderRadius: 4,
                        overflow: 'hidden'
                      }}
                    >
                      <div
                        style={{
                          width: `${percent}%`,
                          height: '100%',
                          background: color(step.status)
                        }}
                      />
                    </div>
                  </div>

                  {/* ARROW */}
                  {i < steps.length - 1 && (
                    <div
                      style={{
                        fontSize: 18,
                        color: '#bbb',
                        marginBottom: 10
                      }}
                    >
                      ➜
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      }
    }
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <div className={'content-block dx-card'}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <CardHeader title='PLANNING PRODUKSI' />
            </Box>
          </Box>
          <Divider />
          {loading ? (
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
              <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
            </Grid>
          ) : (
            <MsiDatagrid array={listData} hiddenColumns={hiddenColumns} customRender={convertComponent} />
          )}
        </div>
      </Grid>
    </Grid>
  )
}
